var LONG_SOURCE_LINE_THRESHOLD = 100
var LONG_SOURCE_CHARACTER_THRESHOLD = 12000
var LONG_SOURCE_PREVIEW_LENGTH = 360

function renderMessageText(value) {
  return renderInlineMarkdown(escapeHtml(value)).replace(/\r?\n/g, '<br>')
}

function renderUserMessageText(value, capabilities) {
  var source = buildCompactSourceMessage(value)
  if (!source) return renderUserText(value, capabilities)
  return renderCompactSourceMessage(source, capabilities)
}

function renderUserText(value, capabilities) {
  var catalog = Array.isArray(capabilities) ? capabilities : []
  var html = renderMessageText(value)
  // Message text and catalogue labels are escaped independently.
  return html.replace(/(^|\s|<br>)([/@])([A-Za-zÀ-ÿ0-9_-]+)/g, function (match, prefix, marker, alias) {
    var normalized = normalizeAlias(alias)
    var item = catalog.find(function (candidate) {
      return [candidate.shortcut].concat(candidate.aliases || []).some(function (name) {
        return normalizeAlias(name) === normalized
      })
    })
    if (!item) return match
    return prefix + '<span class="wc-agent-chip">' + escapeHtml(item.displayName || item.name || alias) + '</span>'
  })
}

function normalizeAlias(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/^[/@]/, '').replace(/_/g, '-').toLowerCase()
}

function buildCompactSourceMessage(value) {
  var text = String(value || '')
  if (!text) return null
  var lineCount = countLines(text)
  var characterCount = text.length
  if (lineCount <= LONG_SOURCE_LINE_THRESHOLD && characterCount <= LONG_SOURCE_CHARACTER_THRESHOLD) return null

  return {
    title: 'Transcript collé',
    lineCount: lineCount,
    size: formatApproximateSize(characterCount),
    status: 'Capturé',
    preview: buildPreview(text),
    fullText: text
  }
}

function renderCompactSourceMessage(source, capabilities) {
  var preview = source.preview
    ? '<div class="wc-compact-source-preview">' + renderUserText(source.preview, capabilities) + '</div>'
    : '<div class="wc-compact-source-preview wc-compact-source-preview-muted">Aperçu masqué.</div>'

  return (
    '<div class="wc-compact-source" data-wc-compact-source="true">' +
      '<div class="wc-compact-source-header">' +
        '<div class="wc-compact-source-title">' + escapeHtml(source.title) + '</div>' +
        '<span class="wc-compact-source-status">' + escapeHtml(source.status) + '</span>' +
      '</div>' +
      '<div class="wc-compact-source-meta">' +
        '<span>' + escapeHtml(formatLineCount(source.lineCount)) + '</span>' +
        '<span>' + escapeHtml(source.size) + '</span>' +
      '</div>' +
      preview +
      '<details class="wc-compact-source-details">' +
        '<summary>Consulter le contenu complet</summary>' +
        '<div class="wc-compact-source-full">' + renderUserText(source.fullText, capabilities) + '</div>' +
      '</details>' +
    '</div>'
  )
}

function countLines(value) {
  if (!value) return 0
  return String(value).split(/\r\n|\r|\n/).length
}

function formatLineCount(count) {
  return count > 1 ? String(count) + ' lignes' : String(count) + ' ligne'
}

function formatApproximateSize(characterCount) {
  if (characterCount < 1000) return String(characterCount) + ' caractères'
  if (characterCount < 1000000) return String(Math.round(characterCount / 100) / 10) + ' k caractères'
  return String(Math.round(characterCount / 100000) / 10) + ' M caractères'
}

function buildPreview(value) {
  var text = String(value || '').trim()
  if (!text) return ''
  var preview = text.slice(0, LONG_SOURCE_PREVIEW_LENGTH).trim()
  if (!preview) return ''
  return preview + (text.length > preview.length ? '...' : '')
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function renderInlineMarkdown(value) {
  return String(value || '').replace(/\*\*(?!\s)([\s\S]*?\S)\s?\*\*/g, function (_, content) {
    return '<strong>' + content + '</strong>'
  })
}

export {
  buildCompactSourceMessage,
  renderMessageText,
  renderUserMessageText
}
